import { useState } from "react";
import { Celda } from "../solicitudes-en-curso/useSolicitudesCurso";
import { modalCargando } from "../../components/ui/sweetAlerts";
import { formatFecha } from "../../utils/funciones";
import { useExcel } from "../../hooks/generarExcel";
import { getUno } from "../../api/apis";
import Swal from "sweetalert2";

export const useHistorialSolicitudes = () => {
  const [historial, setHistorial] = useState(undefined);
  const [historialExcel, setHistorialExcel] = useState([]);
  const { generarExcelNuevo } = useExcel();

  const traerHistorial = async props => {
    const { id } = props;
    const resp = await getUno("gethistorialsolicitudes", { id: id });
    setHistorial(resp.data.data);
  }

  const descargarHistorialExcel = async () => {
    modalCargando("Descargando Historial...");
    try {
      const resp = await getUno("getlistadohistoricoexcel", null, null);
      const lista = resp.data.data;

      // return

      generarExcelNuevo({
        arr: lista,
        nombreArchivo: "Historial"
      });

    } catch (err) {
      console.log({ err });
    }
    Swal.close();
  }

  const arrColumnas = [
    {
      name: "Estado",
      selector: row => <Celda label={row.estado_solicitud_cambio_contractual.nombre} ancho="360px" />,
      width: "360px",
      wrap: true,
    },
    {
      name: "Observaciones",
      selector: row => <Celda label={row.observaciones} ancho="500px" />,
      sortable: false,
      wrap: true,
      width: "500px",
    },
    {
      name: "Fecha",
      selector: row => <Celda label={formatFecha(row.created_at.split(' ')[0])} ancho="100px" />,
      sortable: false,
      style: {
        justifyContent: 'center',
      },
      width: '100px',
      wrap: true,
    },
    {
      name: "Hora",
      selector: row => <Celda label={(row.created_at).split(' ')[1]} ancho="100px" />,
      style: {
        justifyContent: 'center',
      },
      sortable: false,
      width: '100px',
      wrap: true,
    },
  ]

  return {
    traerHistorial, descargarHistorialExcel, historial, historialExcel, arrColumnas
  }
}